module.exports = __webpack_public_path__ + "static/media/cars.b1b109f7.png";